// extracted by mini-css-extract-plugin
export var background = "styles-module--background--3c050";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var statItem = "styles-module--statItem--631bd";
export var statText = "styles-module--statText--5d343";
export var statTitle = "styles-module--statTitle--58e39";
export var tablet = "769px";